import "@css/app.css";

/* JS */
import "lazysizes";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]");

window.disableBodyScroll = disableBodyScroll;
window.enableBodyScroll = enableBodyScroll;

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

const appHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

window.appHeight = appHeight;

const header = document.querySelector(".site-header");

const headerHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty("--header-height", `${header.offsetHeight}px`);
	console.log(header.offsetHeight);
};
window.addEventListener("resize", headerHeight);
headerHeight();

window.headerHeight = headerHeight;

var scrollLockEnabled = false;
let theNav = document.querySelector(".mobile-nav");
function shouldScrollLock() {
	if (!scrollLockEnabled) {
		disableBodyScroll(theNav);
	} else {
		enableBodyScroll(theNav);
	}
	scrollLockEnabled = !scrollLockEnabled;
}

window.shouldScrollLock = shouldScrollLock;

import Swiper from "swiper/bundle";

import "swiper/css/bundle";
import "swiper/css/effect-fade";

// Callout Slider
const calloutSlider = document.querySelector(".callout-slider");
if (calloutSlider) {
	const autoplay = calloutSlider.dataset.autoplay === "1";
	const delay = parseInt(calloutSlider.dataset.delay);
	console.log(autoplay, delay);
	new Swiper(calloutSlider, {
		slidesPerView: 1,
		spaceBetween: 10,
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			728: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
		autoplay: autoplay
			? {
					delay,
					pauseOnMouseEnter: true,
			  }
			: false,
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});
}
// Image Sliders
const imageSliders = document.querySelectorAll(".image-slider");
imageSliders.forEach(imageSlider => {
	const autoplay = imageSlider.dataset.autoplay === "1";
	const delay = parseInt(imageSlider.dataset.delay);
	console.log(autoplay, delay);
	new Swiper(imageSlider, {
		slidesPerView: 1,
		autoplay: autoplay
			? {
					delay,
					pauseOnMouseEnter: true,
			  }
			: false,
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});
});

const swiper2 = new Swiper(".main-slider", {
	loop: true,
	pagination: {
		el: ".swiper-pagination",
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

const swiper3 = new Swiper(".side-slider", {
	loop: true,
	pagination: {
		el: ".swiper-pagination",
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

const homenews = new Swiper(".homenews", {
	loop: true,
	pagination: {
		el: ".swiper-pagination",
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

const sideswiper = new Swiper(".side-swiper", {
	loop: true,
	pagination: {
		el: ".swiper-pagination",
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

import Rellax from "rellax";

function init() {
	var rellax = new Rellax(".rellax");
}

document.addEventListener("DOMContentLoaded", () => {
	init();
});

